<script lang="ts" setup>
import BsNavDropdownItem from '@/legacy/components/NavDropdownItem.vue'

defineProps({
	list: {
		type: Object,
		required: true,
	},
	link: {
		type: String,
		default: '',
	},
	isAlignRight: {
		type: Boolean,
		default: false,
	},
	isSurfaceTextSmall: {
		type: Boolean,
		default: false,
	},
	isHide: {
		type: Boolean,
		default: false,
	},
	newBadgeText: {
		type: String,
		default: 'New',
	},
})
</script>

<template>
	<div
		v-show="!isHide"
		:class="[
			'bs-nav-dropdown',
			{
				'pure-link': list.link,
				'align-right': isAlignRight,
			},
		]"
	>
		<div
			:class="[
				'bs-nav-dropdown__surface',
				{
					small: isSurfaceTextSmall,
				},
			]"
		>
			<template v-if="list.link">
				<a :href="list.link" class="bs-nav-dropdown__surface__link">
					{{ list.name }}
				</a>
			</template>
			<template v-else>
				<div class="bs-nav-dropdown__surface__text">{{ list.name }}</div>
				<i class="bs-icon-arrow-down-new"></i>
			</template>
		</div>
		<div class="bs-nav-dropdown__bottom" v-if="!link">
			<BsNavDropdownItem
				v-for="subMenu in list.children"
				:key="subMenu.name"
				:link="subMenu.link"
				:icon="subMenu.icon"
				:name="subMenu.name"
				:desc="subMenu.desc"
				:isNewBadge="subMenu.isNewBadge"
				:newBadgeText="newBadgeText"
			></BsNavDropdownItem>
		</div>
	</div>
</template>
